<div class="row" *ngIf="garageVisits && summary">
  <div class="col-12 ">
    <h1>Umówienia</h1>
  </div>
</div>

<div class="d-flex justify-content-center flex-nowrap" *ngIf="garageVisits && summary">

  <div class="col-12 " *ngIf="garageVisits && garageVisits.length ==0">
    <div class="menu-box m-2 p-2">
      <div class="menu-box-text p-1">
        Brak umówień.
      </div>
    </div>
  </div>

  <div class="desktop-only text-white mx-2 p-2" *ngIf="garageVisits.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small" *ngIf="garageVisits.length > 0">
      <thead>
        <tr>
          <th>#</th>
          <th>Data umówienia</th>
          <th colspan="4">Serwis</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let garageVisit of garageVisits; let i = index;" [ngStyle]="summary.CurrentGarageVisit &&  summary.CurrentGarageVisit.GarageVisitId == garageVisit.GarageVisitId ? {'background-color': '#00bd3f', 'color':'#fff'} : {}">

          <td>{{i+1}}</td>
          <td>{{ garageVisit.Date| date:'yyyy.MM.dd  HH:mm'}}</td>
          <td>{{ garageVisit.Garage.Name}}</td>
          <td>{{ garageVisit.Garage.City}}</td>
          <td>{{ garageVisit.Garage.Street}}</td>
          <td>{{ garageVisit.Garage.Telephone}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mobile-only text-white mx-2 p-2" *ngIf="garageVisits.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small" *ngIf="garageVisits.length > 0">
      <thead>
        <tr>
          <th>#</th>
          <th>Data umówienia</th>
          <th>Serwis</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let garageVisit of garageVisits; let i = index;" [ngStyle]="summary.CurrentGarageVisit &&  summary.CurrentGarageVisit.GarageVisitId == garageVisit.GarageVisitId ? {'background-color': '#00bd3f', 'color':'#fff'} : {}">

          <td>{{i+1}}</td>
          <td>{{ garageVisit.Date| date:'yyyy.MM.dd  HH:mm'}}</td>
          <td>
            <div>{{ garageVisit.Garage.Name}}</div>
            <div>{{ garageVisit.Garage.City}}</div>
            <div>{{ garageVisit.Garage.Street}}</div>
            <div>{{ garageVisit.Garage.Telephone}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

  <ng-container *ngIf="!garageVisits || !summary">
    <div class="container z-index-master">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
